import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CustomModalStyled from '../CustomModalStyled'
import { ModalContent, StyledChildrenWrapper, StyledDivider } from './styled'

const LaTeXHelpModal = ({ title, modalContent, children }) => {
  const [visible, setVisible] = useState(false)

  const handleOpen = () => setVisible(true)
  const handleClose = () => setVisible(false)

  return (
    <>
      <CustomModalStyled
        visible={visible}
        onCancel={handleClose}
        footer={null}
        title={
          <>
            {title || 'How to use LaTeX'}
            <StyledDivider />
          </>
        }
        modalWidth="910px"
        modalMaxWidth="90vw"
        bodyPadding="20px 0px"
        titleFontSize="22px"
        titleFontWeight={700}
        zIndex={2000}
        closeRightAlign="5px"
      >
        <ModalContent>{modalContent}</ModalContent>
      </CustomModalStyled>
      <StyledChildrenWrapper onClick={handleOpen}>
        {children}
      </StyledChildrenWrapper>
    </>
  )
}

LaTeXHelpModal.propTypes = {
  children: PropTypes.node.isRequired,
  modalContent: PropTypes.node.isRequired,
}

export default LaTeXHelpModal
